var WorkerSourceMap = new Map();
export function registerWorkerSource(workerName, workerSource) {
  WorkerSourceMap.set(workerName, workerSource);
}
export function getWorkerSource(workerName) {
  var workerSource = WorkerSourceMap.get(workerName);
  return workerSource;
}